import { useState, useEffect } from 'react'

export default function Projets({ data }) {
  const [activeId, setActiveId] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const active = data.find((p) => p.id === activeId) || null;

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setLightbox(null); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <section id="projets" className="projets-section">
      <p className="section-label">Projets</p>

      <ul className="projects-list">
        {data.map((project, i) => (
          <li
            key={project.id}
            className={`project-row ${activeId === project.id ? "is-active" : ""}`}
            onClick={() => setActiveId(activeId === project.id ? null : project.id)}
          >
            <span className="project-row-num">{project.num}</span>
            <div className="project-row-thumb" style={{ backgroundImage: `url(${project.image})`, backgroundSize: "cover", backgroundPosition: "center", backgroundColor: "var(--sage-light)" }} />
            <div className="project-row-info">
              <h3 className="project-row-title">{project.title}</h3>
              <p className="project-row-location">{project.location}</p>
            </div>
            <span className="project-row-arrow">→</span>
          </li>
        ))}
      </ul>

      {/* Overlay sombre derrière le panneau */}
      <div
        className={`project-panel-backdrop ${active ? "is-visible" : ""}`}
        onClick={() => setActiveId(null)}
      />

      {/* Panneau latéral */}
      <div className={`project-panel ${active ? "is-open" : ""}`}>
        {active && (
          <>
            <button className="project-panel-close" onClick={() => setActiveId(null)}>×</button>
            <div
              className="project-panel-visual lightbox-trigger"
              style={{ backgroundImage: `url(${active.image})`, backgroundSize: "cover", backgroundPosition: "center", backgroundColor: "var(--sage-light)" }}
              onClick={() => setLightbox(active.image)}
            />
            <div className="project-panel-body">
              <p className="project-panel-num">Projet {active.num}</p>
              <h2 className="project-panel-title">{active.title}</h2>
              <p className="project-panel-location">{active.location}</p>
              <div className="project-panel-divider" />
              <p className="project-panel-desc">{active.desc}</p>
              <p className="project-panel-details">{active.details}</p>
              {active.link && (
                <a
                  className="project-panel-pdf"
                  href={active.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Voir le dossier complet →
                </a>
              )}
              {active.subImages.length > 0 && (
                <div className="project-panel-sub-images">
                  {active.subImages.map((img, i) => (
                    <div
                      key={i}
                      className="project-panel-sub-img lightbox-trigger"
                      style={{ backgroundImage: `url(${img})`, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundColor: "#fff" }}
                      onClick={() => setLightbox(img)}
                    />
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)}>×</button>
          <img className="lightbox-img" src={lightbox} alt="" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </section>
  );
}